<div appearance="outline" fxFlex [formGroup]="settings.form">
  <mat-checkbox [formControlName]="settings.formControlName" [required]="settings.povinnost">{{settings.nazev}}</mat-checkbox>
</div>
